import { render, staticRenderFns } from "./ExperienceDetails.vue?vue&type=template&id=50f55fd2"
import script from "./ExperienceDetails.vue?vue&type=script&lang=js"
export * from "./ExperienceDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports